<!--components\Ui\BotonesLaterales.vue-->
<template>
  <div v-if="debe_mostrarse"
    class="fixed bottom-0 md:bottom-72 right-0 h-auto md:h-36 w-full md:w-auto flex flex-row z-[200] gap-0">
 
    <div class="conjunto w-full md:w-12 h-full flex-row md:flex-col">

      <a id="btn-telefono" class="bg-ROJO_FUERTE_LEON w-full h-12 flex items-center justify-center cursor-pointer border-none transition-all duration-300"
        @click="abrirTelefono">
        <img :src="'/img/home/telefono.webp'" alt="teléfono" class="w-6 h-1/2 transition-transform duration-300" />
      </a>

      <button v-if="mostrar_qr" ref="qrRef"
        class="w-full h-12 flex items-center justify-center cursor-pointer border-none transition-all duration-300"
        :class="color_boton_qr" @click="toggleQr">
        <img :src="qr_url" alt="QR code" class="w-6 h-1/2 transition-transform duration-300" />
      </button>

      <button id="btn-whatsapp" class="w-full h-12 flex items-center justify-center cursor-pointer border-none transition-all duration-300 bg-[#25D366]"
        @click="abrirWhatsapp">
        <img :src="'/img/home/wsp.png'" alt="WhatsApp" class="w-6 h-1/2 transition-transform duration-300" />
      </button>

    </div>

    <Qr v-if="estado_qr" />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import Qr from '~/components/Qr.vue'
import { NEGOCIOS } from '~/constants/negocios'

const config = useRuntimeConfig()

const debug = {
  enabled: config.public.modo === 'DEV',
  log(...args) {
    if (this.enabled) console.log(...args)
  },
  error(...args) {
    if (this.enabled) console.error(...args)
  },
}

const modo_sistema = useState('modo_sistema')
const { fullcercano } = useCartBridge()
const route = useRoute()

const qrRef = ref(null)
const qr_abierto = ref(false)
const qr_url = ref('/img/home/qrsample.webp')
const numero_whatsapp = ref('56950731532')//vambee solicito cambio
const es_movil = ref(false)


const debe_mostrarse = computed(() => {
  const es_home = modo_sistema.value === NEGOCIOS.HOME
  const es_aceites_raiz = route.path === `/${NEGOCIOS.ACEITES}`
  const es_frenos_raiz = route.path === '/frenos'
  const es_afinamiento_raiz = route.path === `/${NEGOCIOS.AFINAMIENTO}`;
  const es_amortiguadores_raiz = route.path == '/amortiguadores';
  const es_trendelantero_raiz = route.path === `/${NEGOCIOS.TRENDELANTERO}`;
  const es_balanceo_raiz = route.path == '/balanceo';
  const es_geometria_raiz = route.path === `/${NEGOCIOS.GEOMETRIA}`;
  const es_kilometraje_raiz = route.path === `/${NEGOCIOS.KILOMETRAJE}`;
  const es_higienizacion_raiz = route.path == '/higienizacion';
  const es_fluidos_raiz = route.path == '/fluidos';
  const es_alineacion_raiz = route.path == '/alineacion';
  const es_electrico_raiz = route.path === `/${NEGOCIOS.ELECTRICO}`;
  const es_accesorios_raiz = route.path == '/accesorios';
  const es_revisiontecnica_raiz = route.path === `/${NEGOCIOS.REVISIONTECNICA}`;

  const es_neumaticos_raiz = route.path === '/neumaticos'
  const es_neumaticos_plp_y_desktop = route.path.startsWith('/neumaticos/plp') && !es_movil.value
  const es_baterias_raiz = route.path === '/baterias'
  const es_baterias_raiz_y_desktop = route.path.startsWith('/baterias/plp') && !es_movil.value

  return (
    es_home || 
    es_neumaticos_raiz || es_neumaticos_plp_y_desktop || 
    es_baterias_raiz || es_baterias_raiz_y_desktop ||
    es_aceites_raiz || 
    es_frenos_raiz || 
    es_afinamiento_raiz || 
    es_amortiguadores_raiz || 
    es_trendelantero_raiz || 
    es_balanceo_raiz || 
    es_geometria_raiz || 
    es_kilometraje_raiz || 
    es_higienizacion_raiz || 
    es_fluidos_raiz || 
    es_alineacion_raiz || 
    es_electrico_raiz || 
    es_accesorios_raiz ||
    es_revisiontecnica_raiz
  )
})

const color_boton_qr = computed(() => qr_abierto.value ? 'bg-[#9E9E9E]' : 'bg-ROJO_LEON')

const mostrar_qr = computed(() => {
  const es_home = modo_sistema.value === NEGOCIOS.HOME && !es_movil.value
  const es_aceites_raiz = route.path === `/${NEGOCIOS.ACEITES}` && !es_movil.value
  const es_frenos_raiz = route.path === '/frenos' && !es_movil.value
  const es_afinamiento_raiz = route.path === `/${NEGOCIOS.AFINAMIENTO}` && !es_movil.value;
  const es_amortiguadores_raiz = route.path == '/amortiguadores' && !es_movil.value;
  const es_trendelantero_raiz = route.path === `/${NEGOCIOS.TRENDELANTERO}` && !es_movil.value;
  const es_balanceo_raiz = route.path == '/balanceo' && !es_movil.value;
  const es_geometria_raiz = route.path === `/${NEGOCIOS.GEOMETRIA}` && !es_movil.value;
  const es_kilometraje_raiz = route.path === `/${NEGOCIOS.KILOMETRAJE}` && !es_movil.value;
  const es_higienizacion_raiz = route.path == '/higienizacion' && !es_movil.value;
  const es_fluidos_raiz = route.path == '/fluidos' && !es_movil.value;
  const es_alineacion_raiz = route.path == '/alineacion' && !es_movil.value;
  const es_electrico_raiz = route.path === `/${NEGOCIOS.ELECTRICO}` && !es_movil.value;
  const es_accesorios_raiz = route.path == '/accesorios' && !es_movil.value;
  const es_revisiontecnica_raiz = route.path === `/${NEGOCIOS.REVISIONTECNICA}` && !es_movil.value;
  const es_neumaticos_raiz_y_desktop = route.path === '/neumaticos' && !es_movil.value
  const es_baterias_raiz_y_desktop = route.path === '/baterias' && !es_movil.value

  return   es_home  
        || es_aceites_raiz 
        || es_frenos_raiz 
        || es_neumaticos_raiz_y_desktop 
        || es_baterias_raiz_y_desktop 
        || es_afinamiento_raiz 
        || es_amortiguadores_raiz 
        || es_trendelantero_raiz 
        || es_balanceo_raiz 
        || es_geometria_raiz 
        || es_kilometraje_raiz 
        || es_higienizacion_raiz 
        || es_fluidos_raiz 
        || es_alineacion_raiz 
        || es_electrico_raiz 
        || es_accesorios_raiz
        || es_revisiontecnica_raiz
})

const estado_qr = computed(() => qr_abierto.value && !es_movil.value)

const toggleQr = () => {
  debug.log("es_movil.value: ", es_movil.value)
  debug.log("qr_abierto.value: ", qr_abierto.value)

  if (es_movil.value) {
    window.open('https://qrco.de/leonservicioautomotriz', '_blank')
  } else {
    qr_abierto.value = !qr_abierto.value
  }
}

const abrirWhatsapp = () => {
  let mensaje = 'Hola, necesito orientación sobre un producto que encontré en la web de LEÓN Servicio Automotriz. ¿Podría un ejecutivo asesorarme?'
  
  if (route.path.startsWith('/neumaticos')) {
    mensaje = 'Hola, necesito orientación sobre neumáticos que encontré en la web de LEÓN Servicio Automotriz. ¿Podría un ejecutivo asesorarme?'
  } else if (route.path === `/${NEGOCIOS.ACEITES}`) {
    mensaje = 'Hola, necesito orientación sobre aceites que encontré en la web de LEÓN Servicio Automotriz. ¿Podría un ejecutivo asesorarme?'
  } else if (route.path === '/frenos') {
    mensaje = 'Hola, necesito orientación sobre agendamiento de frenos que encontré en la web de LEÓN Servicio Automotriz. ¿Podría un ejecutivo asesorarme?'
  } else if (route.path === '/baterias') {
    mensaje = 'Hola, necesito orientación sobre baterías que encontré en la web de LEÓN Servicio Automotriz. ¿Podría un ejecutivo asesorarme?'
  } else if (route.path === `/${NEGOCIOS.AFINAMIENTO}`) {
    mensaje = 'Hola, quisiera revisar afinamiento...';
  } else if (route.path == '/amortiguadores' ) {
      mensaje = 'Hola, quisiera revisar amortiguadores...';
  } else if (route.path === `/${NEGOCIOS.TRENDELANTERO}`) {
      mensaje = 'Hola, quisiera revisar tren delantero...';
  } else if (route.path == '/balanceo' ) {
      mensaje = 'Hola, quisiera revisar balanceo...';
  } else if (route.path === `/${NEGOCIOS.GEOMETRIA}`) {
      mensaje = 'Hola, quisiera revisar geometria...';
  } else if (route.path === `/${NEGOCIOS.KILOMETRAJE}`) {
      mensaje = 'Hola, quisiera revisar kilometraje...';
  } else if (route.path == '/higienizacion' ) {
      mensaje = 'Hola, quisiera revisar higienizacion...';
  } else if (route.path == '/fluidos' ) {
      mensaje = 'Hola, quisiera revisar fluidos...';
  } else if (route.path == '/alineacion' ) {
      mensaje = 'Hola, quisiera revisar alineacion...';
  } else if (route.path === `/${NEGOCIOS.ELECTRICO}`) {
      mensaje = 'Hola, quisiera revisar electrico...';
  } else if (route.path == '/accesorios' ) {
      mensaje = 'Hola, quisiera revisar accesorios...';
  } else if (route.path === `/${NEGOCIOS.REVISIONTECNICA}`) {
      mensaje = 'Hola, quisiera gestionar mi revisión técnica...';
  } else {mensaje = 'Hola, quisiera resolver una duda...'}
  
  const url = `https://api.whatsapp.com/send/?phone=${numero_whatsapp.value}&text=${encodeURIComponent(mensaje)}&type=phone_number&app_absent=0`
  window.open(url, '_blank')
}

const abrirTelefono = () => {
  debug.log("abrirTelefono");

  const popup = document.getElementById('popupLocales')
  if (popup) {
    popup.classList.remove('hidden')
    popup.classList.add('flex')
    document.body.style.overflow = 'hidden'
  }
}

const onClickOutside = (e) => {
  const target = e.target
  if (qrRef.value && !qrRef.value.contains(target) && qr_abierto.value) {
    qr_abierto.value = false
  }
}

const onResize = () => {
  if (typeof window !== 'undefined') {
    es_movil.value = window.innerWidth < 768
  }
}

watch(() => fullcercano.value?.tipo, (tipo) => {
  numero_whatsapp.value = '56950731532'//vambee solicito cambio
  if (route.path.startsWith('/neumaticos/plp') && tipo === 'asociado') {
    numero_whatsapp.value = '56950250324'
  }
}, { immediate: true })

onMounted(() => {
  onResize()
  document.addEventListener('click', onClickOutside)
  window.addEventListener('resize', onResize)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', onClickOutside)
  window.removeEventListener('resize', onResize)
})
</script>

<style scoped>
.conjunto {
  display: flex;
}
</style>